import React, {Component} from 'react';
import {Card, Breadcrumb} from 'semantic-ui-react';
import {Helmet} from "react-helmet";

import CustomDivider from '../../components/extras/CustomDivider';
import CardDash from "../../components/extras/CardDash";
import localDB from "../../data/localDB";

class SaleDash extends Component {
    constructor() {
        super();
        this.state = {
            cards: []
        };
    }

    componentDidMount() {
        this.itemsMenu();
    }

    itemsMenu() {
        let menu = localDB.get('menu');
        let cards = menu.filter(menu => menu.type === 'sales').map(item => {
            return (
                <CardDash {...item} key={item.url}/>
            )
        });
        this.setState({cards});
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Finanzas - Quipuu</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section active>Finanzas</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <Card.Group stackable centered>
                    {this.state.cards}
                </Card.Group>
            </div>
        );
    }
}

export default SaleDash;



// WEBPACK FOOTER //
// ./src/containers/sales/SaleDash.js